// ChangePassword.jsx
import { useState } from 'react';
import { Link } from 'react-router-dom';
import useChangePassword from '../../hooks/useChangePassword';

const PasswordInput = ({ 
    id, 
    value, 
    onChange, 
    error, 
    placeholder, 
    showPassword 
}) => (
    <div className="form-group password-form">
        <div className="change-pswrd-input">
            <input
                type={showPassword ? "text" : "password"}
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={e => onChange(id, e.target.value)}
                className={error ? 'error' : ''}
            />
            <span className="input-icon">
                <img src="/assets/icons/password.png" alt="Password Icon" />
            </span>
        </div>
        {error && <span className="error-text">{error}</span>}
    </div>
);

const ChangePassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    
    const {
        formData,
        errors,
        isSubmitting,
        handleChange,
        handleSubmit
    } = useChangePassword({ isModal: false });

    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleSubmit();
    };

    return (
        <div className="main">
            <div className="main-central-container change-pswrd-container">
                <div className="login-container change-pswrd-secondary-container">
                    <div className="login-box mt-4">
                        <h3>Change Password</h3>
                        
                        <form className="login-form" onSubmit={handleFormSubmit}>
                            <PasswordInput
                                id="oldPassword"
                                value={formData.oldPassword}
                                onChange={handleChange}
                                error={errors.oldPassword}
                                placeholder="Old Password"
                                showPassword={showPassword}
                            />

                            <PasswordInput
                                id="newPassword"
                                value={formData.newPassword}
                                onChange={handleChange}
                                error={errors.newPassword}
                                placeholder="New Password"
                                showPassword={showPassword}
                            />

                            <PasswordInput
                                id="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                error={errors.confirmPassword}
                                placeholder="Confirm Password"
                                showPassword={showPassword}
                            />

                            <div className="row">
                                <div className="col">
                                    <div className="form-check show-pwd mt-2 mb-4">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="showPassword"
                                            checked={showPassword}
                                            onChange={() => setShowPassword(!showPassword)}
                                        />
                                        <label className="form-check-label" htmlFor="showPassword">
                                            Show Password
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary btn-lg btn-xl generalBtn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Changing Password...' : 'Submit'}
                            </button>

                            <div className="text-center mt-3 cancel-btn">
                                <Link to="/login">Cancel</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;